import { Component, Input, OnInit } from '@angular/core';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { environment } from '../../../../../environments/environment';
import {
  LandlineConsumptionInterfaceState,
} from '../../store/state/land-line-consumption.state';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { ConsumptionInterface } from '../../../lines/models/consumption.interface';

@Component({
  selector: 'app-land-line-consumption',
  templateUrl: './land-line-consumption.component.html',
  styleUrls: ['./land-line-consumption.component.css'],
  standalone: false
})
export class LandLineConsumptionComponent implements OnInit {

  @Input()
  selectedLandLine: LandLineListInterface;

  environment = environment;
  landlineConsumption: LandlineConsumptionInterface = null;
  brand?: string;
  displaySupportInformation: boolean;
  detailsVisibility: boolean = true;
  detailsButtonText: string = 'Voir le détail';
  constructor(
      private store: Store<any>,
      private extranetService: ExtranetService,
  ) { }

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE_CONSUMPTION)).subscribe((response: LandlineConsumptionInterfaceState) => {
      if (false === (response.landlineConsumption instanceof Array) && null !== response.landlineConsumption) {
        this.landlineConsumption = response.landlineConsumption;
      }
    });
    this.brand = environment.data.brand;
    this.displaySupportInformation = false;
    if (this.extranetService.getSupportUser()) {
      this.displaySupportInformation = true;
    }
  }

  displayDetails() {
    this.detailsVisibility = !this.detailsVisibility;
    if (this.detailsVisibility) {
      this.detailsButtonText = 'Voir le détail';
    } else {
      this.detailsButtonText = 'Masquer le détail';
    }
  }

  getDate(consumption: ConsumptionInterface, selectedLandLine: LandLineListInterface, index: number) {
    const activationSimDate = selectedLandLine.billingStartDate.split('-');
    if (selectedLandLine.status === 'waiting_port' && index === 1) {
      return activationSimDate[2] + '/' + activationSimDate[1] + '/' + activationSimDate[0];
    } else if (selectedLandLine.status === 'waiting_port' && index === 2) {
      return consumption.date;
    }

    let startDate = consumption.date;
    const splitDate = consumption.date.split('/');
    if (splitDate.length > 0 && splitDate[0] !== '01') {
      if (parseInt(activationSimDate[1], 10) === parseInt(splitDate[1], 10) && parseInt(activationSimDate[2], 10) === parseInt(splitDate[2], 10)) {
        startDate = activationSimDate[2] + '/' + activationSimDate[1] + '/' + activationSimDate[0];
      } else {
        startDate = '01/' + splitDate[1] + '/' + splitDate[2];
      }
    }
    return startDate;
  }
}
